<script>
  import FlashBanner from '@/components/FlashBanner.svelte';
  import ThreadsPostModal from '@/components/ThreadsPostModal.svelte';
  import { onMount } from 'svelte';

  let {
    boards = [],
    current_user = null,
    stats = { total_posts: 0, total_members: 0, today_posts: 0, online_members: 0 },
    recent_posts = [],
    popular_posts = [],
    threads_posts = []
  } = $props()

  // Modal state
  let isModalOpen = $state(false);
  let selectedPost = $state(null);

  function openThreadsPost(post) {
    selectedPost = post;
    isModalOpen = true;
  }

  function closeModal() {
    isModalOpen = false;
    selectedPost = null;
  }

  const FAVORITE_BOARDS_KEY = 'favoriteBoards'
  let favoriteBoards = $state({})

  // 현재 시간에 따른 인사말
  function getGreeting() {
    const hour = new Date().getHours()
    if (hour < 12) return '좋은 아침이에요'
    if (hour < 18) return '좋은 오후예요'
    return '좋은 저녁이에요'
  }

  // 시간 포맷
  function formatTime(dateString) {
    if (!dateString) return ''
    const date = new Date(dateString)
    const now = new Date()
    const diff = now - date
    const minutes = Math.floor(diff / 60000)
    const hours = Math.floor(diff / 3600000)
    const days = Math.floor(diff / 86400000)

    if (minutes < 1) return '방금 전'
    if (minutes < 60) return `${minutes}분 전`
    if (hours < 24) return `${hours}시간 전`
    if (days < 7) return `${days}일 전`
    return date.toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' })
  }

  // 게시판 아이콘 (SVG path data)
  function getBoardIcon(board) {
    const slug = board?.slug
    const icons = {
      notice: 'M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z',
      free: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
      qna: 'M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
      info: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
      jobs: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2M3 13a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2 2v4z',
      humor: 'M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
    }
    return icons[slug] || 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2'
  }

  // 게시판 색상
  function getBoardColor(board) {
    const slug = board?.slug
    const colors = {
      notice: { bg: 'bg-amber-50 dark:bg-amber-900/20', text: 'text-amber-700 dark:text-amber-300', border: 'border-amber-200 dark:border-amber-800' },
      free: { bg: 'bg-blue-50 dark:bg-blue-900/20', text: 'text-blue-700 dark:text-blue-300', border: 'border-blue-200 dark:border-blue-800' },
      qna: { bg: 'bg-purple-50 dark:bg-purple-900/20', text: 'text-purple-700 dark:text-purple-300', border: 'border-purple-200 dark:border-purple-800' },
      info: { bg: 'bg-emerald-50 dark:bg-emerald-900/20', text: 'text-emerald-700 dark:text-emerald-300', border: 'border-emerald-200 dark:border-emerald-800' },
      jobs: { bg: 'bg-orange-50 dark:bg-orange-900/20', text: 'text-orange-700 dark:text-orange-300', border: 'border-orange-200 dark:border-orange-800' },
      humor: { bg: 'bg-pink-50 dark:bg-pink-900/20', text: 'text-pink-700 dark:text-pink-300', border: 'border-pink-200 dark:border-pink-800' }
    }
    return colors[slug] || { bg: 'bg-surface-tertiary', text: 'text-gray-700 dark:text-dark-text-medium', border: 'border-default' }
  }

  function loadFavoriteBoards() {
    if (typeof window === 'undefined') return

    try {
      const saved = localStorage.getItem(FAVORITE_BOARDS_KEY)
      if (saved) {
        favoriteBoards = JSON.parse(saved)
      }
    } catch (error) {
      favoriteBoards = {}
    }
  }

  function saveFavoriteBoards() {
    if (typeof window === 'undefined') return
    localStorage.setItem(FAVORITE_BOARDS_KEY, JSON.stringify(favoriteBoards))
    window.dispatchEvent(new CustomEvent('favorite-boards:updated'))
  }

  function isFavoriteBoard(slug) {
    return Boolean(favoriteBoards?.[slug])
  }

  function toggleFavoriteBoard(event, board) {
    event.preventDefault()
    event.stopPropagation()

    if (!board?.slug) return

    if (isFavoriteBoard(board.slug)) {
      const nextFavorites = { ...favoriteBoards }
      delete nextFavorites[board.slug]
      favoriteBoards = nextFavorites
    } else {
      favoriteBoards = {
        ...favoriteBoards,
        [board.slug]: {
          slug: board.slug,
          name: board.name
        }
      }
    }

    saveFavoriteBoards()
  }

  onMount(() => {
    loadFavoriteBoards()
  })
</script>

<div class="space-y-6">
  <FlashBanner />


  <!-- Hero Section with Welcome Message -->
  <header class="card card-bordered overflow-hidden bg-gradient-to-r from-white to-gray-50/70 dark:from-dark-secondary dark:to-dark-tertiary/50">
    <div class="py-8 lg:py-10 px-6 lg:px-8">
      <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <!-- Welcome Message -->
        <div class="flex-1">
          <p class="text-caption font-medium text-primary mb-2">{getGreeting()} <svg class="w-5 h-5 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"/></svg></p>
          <h1 class="text-display text-content mb-2">
            {#if current_user}
              {current_user.name}님
            {:else}
              커뮤니티
            {/if}
          </h1>
          <p class="text-body1 text-content-secondary">
            다양한 이야기와 정보를 나누어 보세요
          </p>
        </div>

        <!-- Quick Stats -->
        <div class="flex flex-wrap items-center gap-3 lg:gap-4">
          <a
            href="/boards?favorites=1#favorite-spaces"
            class="inline-flex items-center gap-2 rounded-xl border border-primary-200 dark:border-primary-700 bg-primary-50 dark:bg-primary-900/25 px-3.5 py-2.5 text-sm font-medium text-primary hover:bg-primary-100 dark:hover:bg-primary-900/40 transition-colors"
            aria-label="즐겨찾기 스페이스 바로가기"
          >
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
            </svg>
            즐겨찾기
          </a>
          <div class="flex items-center gap-3 bg-surface-tertiary rounded-lg px-4 py-3 border border-default">
            <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
            <div>
              <p class="text-xs text-gray-600 dark:text-dark-text-low">전체 회원</p>
              <p class="font-semibold text-content">{stats.total_members?.toLocaleString() || '0'}</p>
            </div>
          </div>
          <div class="flex items-center gap-3 bg-surface-tertiary rounded-lg px-4 py-3 border border-default">
            <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
            <div>
              <p class="text-xs text-gray-600 dark:text-dark-text-low">전체 게시글</p>
              <p class="font-semibold text-content">{stats.total_posts?.toLocaleString() || '0'}</p>
            </div>
          </div>
          <div class="flex items-center gap-3 bg-surface-tertiary rounded-lg px-4 py-3 border border-default">
            <svg class="w-6 h-6 text-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"/></svg>
            <div>
              <p class="text-xs text-gray-600 dark:text-dark-text-low">오늘 새 글</p>
              <p class="font-semibold text-content">{stats.today_posts || '0'}</p>
            </div>
          </div>
          {#if stats.online_members > 0}
            <div class="flex items-center gap-3 bg-surface-tertiary rounded-lg px-4 py-3 border border-default">
              <span class="relative flex h-2.5 w-2.5">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
              </span>
              <div>
                <p class="text-xs text-gray-600 dark:text-dark-text-low">접속 중</p>
                <p class="font-semibold text-content">{stats.online_members}</p>
              </div>
            </div>
          {/if}
        </div>
      </div>

      <!-- Search Bar -->
      <div class="mt-6 max-w-3xl">
        <div class="relative">
          <input
            type="text"
            placeholder="게시판, 게시글 검색..."
            class="w-full rounded-xl border border-default bg-surface pl-12 pr-4 py-3.5 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary/50 transition-all"
          />
          <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content - Bento Box Layout -->
  <main class="py-6 lg:py-8">
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-6">

      <!-- Left Column - Boards Grid -->
      <div class="lg:col-span-8 space-y-6">
        <!-- Section Header -->
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-primary-100 dark:bg-primary-900/30 rounded-xl flex items-center justify-center">
              <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/></svg>
            </div>
            <div>
              <h2 class="text-h2 text-gray-900 dark:text-white">스페이스</h2>
              <p class="text-caption text-gray-500 dark:text-gray-400">관심 주제를 선택하거나 우측 상단 즐겨찾기로 사이드바에서 바로 접속하세요</p>
            </div>
          </div>
          <a href="/" class="text-caption text-primary hover:text-primary-700 dark:hover:text-primary-300 font-medium flex items-center gap-1 transition-colors">
            홈으로
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </a>
        </div>

        <!-- 게시판 블록 — 아카라이브 채널 목록처럼 게시판마다 최근 글이 흐른다.
             높이가 글 수만큼 달라지도록 그리드 대신 다단(columns)으로 쌓는다. -->
        <div id="favorite-spaces" class="columns-1 sm:columns-2 gap-4 [column-fill:balance]">
          {#each boards as board (board.slug)}
            {@const colors = getBoardColor(board)}
            {@const latest = board.latest_posts || []}
            <section class="mb-4 break-inside-avoid card card-bordered overflow-hidden">
              <header class="flex items-center gap-2 px-4 py-3 border-b border-default {colors.bg}">
                <svg class="w-4 h-4 shrink-0 {colors.text}" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d={getBoardIcon(board)}/>
                </svg>
                <a href={`/boards/${board.slug}`} class="font-bold text-sm {colors.text} hover:underline truncate">
                  {board.name}
                </a>
                <span class="text-xs text-gray-500 dark:text-gray-400 shrink-0">{board.posts_count || 0}</span>
                <!-- 잠금 배지는 서버 판정(`accessible`)만 본다(2026-08-24). -->
                {#if board.accessible === false}
                  <span class="text-[11px] text-amber-600 dark:text-amber-400 font-medium px-1.5 py-0.5 bg-white/70 dark:bg-amber-900/30 rounded-full flex items-center gap-1 shrink-0">
                    <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/>
                    </svg>
                    {board.lock_reason === 'company_verification' ? '인증 필요' : '접근 제한'}
                  </span>
                {/if}
                <span class="flex-1"></span>
                <button
                  type="button"
                  class="inline-flex h-7 w-7 items-center justify-center rounded-md text-gray-400 hover:text-warning transition-colors shrink-0"
                  aria-label={isFavoriteBoard(board.slug) ? `${board.name} 즐겨찾기 해제` : `${board.name} 즐겨찾기 추가`}
                  title={isFavoriteBoard(board.slug) ? '즐겨찾기 해제' : '즐겨찾기 추가'}
                  onclick={(event) => toggleFavoriteBoard(event, board)}
                >
                  <svg class="w-4 h-4 {isFavoriteBoard(board.slug) ? 'text-warning' : ''}" fill={isFavoriteBoard(board.slug) ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.914c.969 0 1.371 1.24.588 1.81l-3.975 2.888a1 1 0 00-.364 1.118l1.519 4.674c.3.921-.755 1.688-1.54 1.118l-3.975-2.888a1 1 0 00-1.176 0l-3.975 2.888c-.784.57-1.838-.197-1.539-1.118l1.519-4.674a1 1 0 00-.364-1.118L2.98 10.1c-.783-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.616-4.674z"/>
                  </svg>
                </button>
              </header>

              {#if latest.length > 0}
                <ul class="divide-y divide-gray-100 dark:divide-dark-border">
                  {#each latest as post (post.id)}
                    <li>
                      <a href={`/posts/${post.id}`} class="flex items-baseline gap-2 px-4 py-2 text-sm hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors">
                        <span class="w-14 shrink-0 text-xs text-gray-400 dark:text-gray-500 tabular-nums">{formatTime(post.created_at)}</span>
                        <span class="truncate text-gray-800 dark:text-gray-100">{post.title}</span>
                        {#if post.comments_count > 0}
                          <span class="shrink-0 text-xs font-semibold text-primary">[{post.comments_count}]</span>
                        {/if}
                      </a>
                    </li>
                  {/each}
                </ul>
              {:else}
                <p class="px-4 py-4 text-body2 text-gray-500 dark:text-gray-400 [word-break:keep-all]">
                  {#if board.accessible === false}
                    {board.lock_reason === 'company_verification' ? '소속 인증을 마치면 글이 보여요.' : '이 게시판은 볼 수 없어요.'}
                  {:else}
                    {board.description || '아직 글이 없어요.'}
                  {/if}
                </p>
              {/if}

              <a href={`/boards/${board.slug}`} class="block px-4 py-2 text-right text-xs font-medium text-primary hover:text-primary-700 border-t border-default">
                더 보기 →
              </a>
            </section>
          {/each}
        </div>

        {#if boards.length === 0}
          <div class="card card-bordered p-12 text-center">
            <div class="w-20 h-20 bg-surface-tertiary rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-10 h-10 text-gray-400 dark:text-dark-text-disabled" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/></svg>
            </div>
            <h3 class="text-h2 text-gray-900 dark:text-white mb-2">아직 게시판이 없어요</h3>
            <p class="text-caption text-gray-500 dark:text-gray-400">곧 다양한 스페이스가 준비될 예정입니다</p>
          </div>
        {/if}
      </div>

      <!-- Right Sidebar -->
      <div class="lg:col-span-4 space-y-6">

        <!-- Recent Activity Card -->
        <div class="card card-bordered overflow-hidden">
          <div class="p-4 border-b border-default">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <svg class="w-5 h-5 text-warning" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"/></svg>
                <h3 class="text-label text-gray-900 dark:text-white">최근 활동</h3>
              </div>
              <a href="/boards" class="text-xs text-primary hover:text-primary-700 font-medium">전체보기</a>
            </div>
          </div>

          <div class="divide-y divide-gray-200 dark:divide-dark-border">
            {#if recent_posts.length > 0}
              {#each recent_posts.slice(0, 5) as post}
                <a href={`/posts/${post.id}`} class="block p-4 hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors">
                  <div class="flex items-start gap-3">
                    <div class="w-8 h-8 rounded-full bg-gradient-to-br from-primary-400 to-primary-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                      {post.user?.name?.[0] || '?'}
                    </div>
                    <div class="flex-1 min-w-0">
                      <p class="text-body2 font-medium text-gray-900 dark:text-white truncate">{post.title}</p>
                      <div class="flex items-center gap-2 mt-1">
                        <span class="text-xs text-gray-500 dark:text-gray-400">{post.user?.name || '익명'}</span>
                        <span class="text-xs text-gray-400 dark:text-gray-500">·</span>
                        <span class="text-xs text-gray-400 dark:text-gray-500">{formatTime(post.created_at)}</span>
                      </div>
                    </div>
                  </div>
                </a>
              {/each}
            {:else}
              <div class="p-8 text-center">
                <p class="text-body2 text-gray-500 dark:text-gray-400">아직 활동이 없어요</p>
              </div>
            {/if}
          </div>
        </div>

        <!-- Popular Posts Card -->
        <div class="card card-bordered overflow-hidden">
          <div class="p-4 border-b border-default">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <svg class="w-5 h-5 text-warning" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                <h3 class="text-label text-gray-900 dark:text-white">인기 게시글</h3>
              </div>
            </div>
          </div>

          <div class="divide-y divide-gray-200 dark:divide-dark-border">
            {#if popular_posts.length > 0}
              {#each popular_posts.slice(0, 5) as post, index}
                <a href={`/posts/${post.id}`} class="block p-4 hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors">
                  <div class="flex items-start gap-3">
                    <span class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold {index < 3 ? 'bg-primary text-white' : 'bg-surface-tertiary text-gray-500 dark:text-gray-400'}">
                      {index + 1}
                    </span>
                    <div class="flex-1 min-w-0">
                      <p class="text-body2 font-medium text-gray-900 dark:text-white truncate">{post.title}</p>
                      <div class="flex items-center gap-2 mt-1">
                        <span class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1">
                          <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"/>
                          </svg>
                          {post.likes_count || 0}
                        </span>
                        <span class="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1">
                          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
                          </svg>
                          {post.comments_count || 0}
                        </span>
                      </div>
                    </div>
                  </div>
                </a>
              {/each}
            {:else}
              <div class="p-8 text-center">
                <p class="text-body2 text-gray-500 dark:text-gray-400">인기 게시글이 없어요</p>
              </div>
            {/if}
          </div>
        </div>

        <!-- Quick Links Card -->
        <div class="bg-gradient-to-br from-primary-50 to-primary-100 dark:from-primary-900/30 dark:to-primary-800/30 rounded-2xl p-5 border-2 border-primary-200 dark:border-primary-700 shadow-sm">
          <h3 class="text-label text-gray-900 dark:text-white mb-3 flex items-center gap-2">
            <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
            빠른 메뉴
          </h3>
          <div class="grid grid-cols-2 gap-2">
            <a href="/messages" class="flex items-center gap-2 bg-surface rounded-xl p-3 border border-default hover:shadow-md hover:border-primary-300 dark:hover:border-primary-500 transition-all group">
              <svg class="w-5 h-5 text-primary group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>
              <span class="text-body2 font-medium text-gray-700 dark:text-gray-200">메시지</span>
            </a>
            <a href="/notifications" class="flex items-center gap-2 bg-surface rounded-xl p-3 border border-default hover:shadow-md hover:border-primary-300 dark:hover:border-primary-500 transition-all group">
              <svg class="w-5 h-5 text-primary group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg>
              <span class="text-body2 font-medium text-gray-700 dark:text-gray-200">알림</span>
            </a>
            <a href="/profile" class="flex items-center gap-2 bg-surface rounded-xl p-3 border border-default hover:shadow-md hover:border-primary-300 dark:hover:border-primary-500 transition-all group">
              <svg class="w-5 h-5 text-primary group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
              <span class="text-body2 font-medium text-gray-700 dark:text-gray-200">프로필</span>
            </a>
            <a href="/dashboard" class="flex items-center gap-2 bg-surface rounded-xl p-3 border border-default hover:shadow-md hover:border-primary-300 dark:hover:border-primary-500 transition-all group">
              <svg class="w-5 h-5 text-primary group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>
              <span class="text-body2 font-medium text-gray-700 dark:text-gray-200">마이페이지</span>
            </a>
          </div>
        </div>

        <!-- Community Guidelines -->
        <div class="card card-bordered p-5">
          <h3 class="text-label text-gray-900 dark:text-white mb-3 flex items-center gap-2">
            <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
            커뮤니티 가이드
          </h3>
          <ul class="space-y-2 text-caption text-gray-600 dark:text-gray-400">
            <li class="flex items-start gap-2">
              <span class="text-green-500 mt-0.5">✓</span>
              <span>서로 존중하며 대화해요</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-green-500 mt-0.5">✓</span>
              <span>개인정보는 공유하지 않아요</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-green-500 mt-0.5">✓</span>
              <span>건전한 토론 문화를 만들어요</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>

  <!-- choi.ai 스레드 섹션 -->
  {#if threads_posts.length > 0}
    <section class="py-6 lg:py-8">
      <div class="mb-6">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-gradient-to-br from-purple-100 to-pink-100 dark:from-purple-900/30 dark:to-pink-900/30 rounded-xl flex items-center justify-center">
              <svg class="w-5 h-5 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
              </svg>
            </div>
            <div>
              <h2 class="text-h2 text-gray-900 dark:text-white flex items-center gap-2">
                choi.ai 스레드
                <span class="text-xs font-normal text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-900/30 px-2 py-1 rounded-full">
                  @choi.openai
                </span>
              </h2>
              <p class="text-caption text-gray-500 dark:text-gray-400">Threads에서 공유하는 AI & Tech 이야기</p>
            </div>
          </div>
          <a
            href="/admin/threads_posts"
            class="text-caption text-primary hover:text-primary-700 dark:hover:text-primary-300 font-medium flex items-center gap-1 transition-colors"
          >
            전체보기
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </a>
        </div>
      </div>

      <!-- Threads 게시글 그리드 -->
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {#each threads_posts as post}
          <button
            type="button"
            onclick={() => openThreadsPost(post)}
            class="group card card-bordered overflow-hidden hover:shadow-xl hover:shadow-purple-200/50 dark:hover:shadow-purple-900/30 hover:border-purple-300 dark:hover:border-purple-600 hover:-translate-y-1 transition-all duration-300 text-left cursor-pointer"
          >
            <div class="p-5">
              <!-- Author Info -->
              <div class="flex items-center gap-3 mb-4">
                {#if post.authorAvatarUrl}
                  <img
                    src={post.authorAvatarUrl}
                    alt={post.authorUsername}
                    class="w-10 h-10 rounded-full ring-2 ring-purple-200 dark:ring-purple-800"
                  />
                {:else}
                  <div class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-pink-500 flex items-center justify-center text-white font-bold ring-2 ring-purple-200 dark:ring-purple-800">
                    {post.authorUsername?.[0]?.toUpperCase() || 'C'}
                  </div>
                {/if}
                <div class="flex-1 min-w-0">
                  <p class="font-semibold text-gray-900 dark:text-white text-sm truncate">
                    {post.authorDisplayName || post.authorUsername}
                  </p>
                  <p class="text-xs text-gray-500 dark:text-gray-400">
                    {formatTime(post.postedAt)}
                  </p>
                </div>
                <!-- View Icon -->
                <svg class="w-4 h-4 text-gray-400 group-hover:text-purple-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                </svg>
              </div>

              <!-- Content -->
              <p class="text-body2 text-gray-700 dark:text-gray-300 line-clamp-4 mb-4">
                {post.content}
              </p>

              <!-- Media Preview -->
              {#if post.hasMedia && post.mediaUrls?.length > 0}
                <div class="mb-4 rounded-lg overflow-hidden bg-black/5 dark:bg-white/5 relative">
                  {#if post.mediaType === 'VIDEO'}
                    <video
                      src={post.mediaUrls[0]}
                      muted
                      playsinline
                      preload="metadata"
                      class="w-full h-40 object-cover"
                      poster={post.mediaUrls.length > 1 ? post.mediaUrls[1] : undefined}
                    >
                      <track kind="captions" />
                    </video>
                    <!-- Play Icon Overlay -->
                    <div class="absolute inset-0 flex items-center justify-center">
                      <div class="w-10 h-10 rounded-full bg-black/50 flex items-center justify-center backdrop-blur-sm">
                        <svg class="w-5 h-5 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M8 5v14l11-7z"/>
                        </svg>
                      </div>
                    </div>
                  {:else if post.mediaType === 'IMAGE' || post.mediaType === 'CAROUSEL_ALBUM'}
                    <img
                      src={post.mediaUrls[0]}
                      alt="게시글 이미지"
                      class="w-full h-40 object-cover"
                      loading="lazy"
                    />
                    {#if post.mediaType === 'CAROUSEL_ALBUM' && post.mediaUrls.length > 1}
                      <div class="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-black/50 text-white text-xs backdrop-blur-sm">
                        +{post.mediaUrls.length - 1}
                      </div>
                    {/if}
                  {/if}
                </div>
              {/if}

              <!-- Thread Indicator -->
              {#if post.hasThread}
                <div class="mb-4 flex items-center gap-2 text-xs text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-900/20 rounded-lg px-3 py-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
                  </svg>
                  <span>스레드 {post.threadRepliesCount}개 더보기</span>
                </div>
              {/if}

              <!-- Stats -->
              <div class="flex items-center gap-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                <div class="flex items-center gap-1.5 text-caption text-gray-500 dark:text-gray-400">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                  </svg>
                  <span>{post.likesCount?.toLocaleString() || 0}</span>
                </div>
                <div class="flex items-center gap-1.5 text-caption text-gray-500 dark:text-gray-400">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
                  </svg>
                  <span>{post.repliesCount?.toLocaleString() || 0}</span>
                </div>
                {#if post.hasMedia}
                  <div class="flex items-center gap-1.5 text-caption text-gray-500 dark:text-gray-400">
                    {#if post.mediaType === 'VIDEO'}
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                      </svg>
                      <span>영상</span>
                    {:else}
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                      </svg>
                      <span>이미지</span>
                    {/if}
                  </div>
                {/if}
              </div>
            </div>

            <!-- Hover Gradient Overlay -->
            <div class="absolute inset-0 bg-gradient-to-t from-purple-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
          </button>
        {/each}
      </div>
    </section>
  {/if}

  <!-- Threads Post Modal -->
  <ThreadsPostModal
    post={selectedPost}
    isOpen={isModalOpen}
    onClose={closeModal}
  />

  <!-- Floating Action Button (Mobile) -->
  <div class="fixed bottom-6 right-6 lg:hidden z-50">
    <a
      href="/boards?write=1"
      aria-label="새 글 작성"
      title="새 글 작성"
      class="flex items-center justify-center w-14 h-14 bg-primary text-white rounded-full shadow-lg hover:shadow-xl hover:bg-primary-600 active:scale-95 transition-all"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
    </a>
  </div>
</div>
